import React, { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import products from "../data/products";
import { CartContext } from "../context/CartContext";
import { FaHeart, FaStar, FaCheckCircle } from "react-icons/fa";
import "./ProductDetails.css";

const ProductDetails = () => {
  const { id } = useParams();

  const {
    addToCart,
    addToWishlist,
    removeFromWishlist,
    wishlist,
  } = useContext(CartContext);

  const product = products.find(
    (item) => item.id.toString() === id
  );

  const [mainImage, setMainImage] = useState(product?.images?.[0]);
  const [qty, setQty] = useState(1);
  const [message, setMessage] = useState("");

  if (!product) return <h2>Product not found</h2>;

  const isInWishlist = wishlist.some(
    (item) => item.id === product.id
  );

  const handleAddToCart = () => {
    addToCart({ ...product, qty });
    setMessage("Item added to Cart");
    setTimeout(() => setMessage(""), 2500);
  };

  const handleWishlist = () => {
    if (isInWishlist) {
      removeFromWishlist(product.id);
      setMessage("Removed from Wishlist");
    } else {
      addToWishlist(product);
      setMessage("Added to Wishlist");
    }
    setTimeout(() => setMessage(""), 2500);
  };

  return (
    <>
      {message && (
        <div className="toast">
          <FaCheckCircle className="toast-icon" />
          <span>{message}</span>
          <div className="progress-bar"></div>
        </div>
      )}

      <div className="product-details">

        {/* LEFT */}
        <div className="product-images">
          <div className="thumbnail-list">
            {product.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt="thumb"
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>

          <div className="main-image">
            <img src={mainImage} alt={product.name} />
          </div>
        </div>

        {/* RIGHT */}
        <div className="product-info">

          <div className="wishlist-icon" onClick={handleWishlist}>
            <FaHeart className={isInWishlist ? "active" : ""} />
          </div>

          <h2 className="product-title">{product.name}</h2>

          <div className="rating">
            {[1,2,3,4,5].map((star) => (
              <FaStar key={star} className="star" />
            ))}
            <span>(120 reviews)</span>
          </div>

          <p className="product-price">₹{product.price}</p>
          <p className="product-desc">{product.description}</p>

          {/* Color */}
          <div className="product-option">
            <label>Colors</label>
            <select>
              <option>Red</option>
              <option>Blue</option>
              <option>Black</option>
            </select>
          </div>

          {/* ✅ UPDATED QUANTITY */}
          <div className="product-option">
            <label>Quantity</label>

            <div className="qty-box">
              <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>

              <input
                type="number"
                value={qty}
                min="1"
                onChange={(e) => {
                  const value = Math.max(1, Number(e.target.value));
                  setQty(value);
                }}
              />

              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>
          </div>

          <button className="add-cart-btn" onClick={handleAddToCart}>
            Add to Cart
          </button>

        </div>
      </div>
    </>
  );
};

export default ProductDetails;